export class SeededRandom {
    constructor(seed) {
        this.seed = seed;
    }
    get currentSeed() { return this.seed; }
    next() {
        // mulberry32
        let t = (this.seed += 0x6D2B79F5);
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    }
    // Returns a random integer between min (inclusive) and max (inclusive)
    nextInt(min, max) {
        return Math.floor(this.next() * (max - min + 1)) + min;
    }
    shuffle(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(this.next() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }
    select(array) {
        return array[Math.floor(this.next() * array.length)];
    }
}
function hashStr(str) {
    // 32-bit FNV-1a hash
    let h = 0x811c9dc5;
    for (let i = 0; i < str.length; i++) {
        h ^= str.charCodeAt(i);
        h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
    }
    return h >>> 0;
}
export function createRng(seed) { return new SeededRandom(seed); }
export function createRngFromStr(str) { return new SeededRandom(hashStr(str)); }
